import { render, staticRenderFns } from "./UploadFileDrop.vue?vue&type=template&id=03643cdb&scoped=true&"
import script from "./UploadFileDrop.vue?vue&type=script&lang=js&"
export * from "./UploadFileDrop.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileDrop.vue?vue&type=style&index=0&id=03643cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03643cdb",
  null
  
)

export default component.exports